import { render } from "./findPassWord.vue?vue&type=template&id=764451c1"
import script from "./findPassWord.vue?vue&type=script&lang=js"
export * from "./findPassWord.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__